import api from "@/lib/axios";

export interface MentorLicensee {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  createdAt: string;
}

export enum MentorLicenseesKeys {
  GET_LICENSEES = "mentor-get-licensees",
}

// Fetch licensees for the authenticated mentor.
// The backend should infer the mentor via the JWT (auth0Id) and apply filtering.
export const getMentorLicensees = async (
  search?: string,
  sortBy?: string,
  sortOrder?: "asc" | "desc",
  skip?: number,
  limit?: number,
) => {
  const params: Record<string, string> = {};
  if (search) params.search = search;
  if (sortBy) params.sortBy = sortBy;
  if (sortOrder) params.sortOrder = sortOrder;
  if (skip !== undefined) params.skip = String(skip);
  if (limit !== undefined) params.limit = String(limit);

  // Call the mentor-scoped endpoint; server infers mentor via auth token
  const response = await api.get("/licensees/by-mentor", { params });

  if (response.data && "data" in response.data) {
    return {
      items: response.data.data as MentorLicensee[],
      total: response.data.total as number,
      skip: response.data.skip as number,
      limit: response.data.limit as number,
    };
  }

  if (Array.isArray(response.data)) {
    return {
      items: response.data as MentorLicensee[],
      total: response.data.length,
      skip: skip || 0,
      limit: limit || response.data.length,
    };
  }

  return {
    items: [],
    total: 0,
    skip: skip || 0,
    limit: limit || 10,
  };
};
